import { PREV_IMG } from "../../constants/endPoints";

// Full-width banner, fixed height. Just an image that links out.
const MotorAd = ({ ad, ...props }) => {
    if (!ad || !ad.image || !ad.image.img_path) return null;

    return (
        <div
            className="motor-ad-banner cont w-100"
            style={{ margin: "22px auto", cursor: ad.url ? "pointer" : "default" }}
            onClick={() => { if (ad.url) window.open(ad.url, "_blank"); }}
        >
            <img
                src={PREV_IMG + ad.image.img_path}
                alt={ad.name || "Ad"}
                style={{
                    width: "100%",
                    height: "300px",
                    objectFit: "cover",
                    borderRadius: "10px",
                    display: "block",
                }}
            />
        </div>
    );
};

export default MotorAd;
